import { render, staticRenderFns } from "./EditAskOpinion.vue?vue&type=template&id=50d746c2&scoped=true&"
import script from "./EditAskOpinion.vue?vue&type=script&lang=ts&"
export * from "./EditAskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./EditAskOpinion.vue?vue&type=style&index=0&id=50d746c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d746c2",
  null
  
)

export default component.exports